export default 'M0 4.5h24v-3H0zm0 6h18v-3H0zm0 6h24v-3H0zm0 6h18v-3H0z';